import _ from 'underscore';
import { createSelector } from 'reselect';
import entitiesSelector from './entities_selector';
import teachersSelector from './teachers_selector';
import cohortsSelector from './cohorts_selector';

const getParticipantGroups = createSelector(
	(state, selector) => selector.getAll(state),
	(state, selector) => selector.getState(state).selectedGroups,
	(participants, selectedGroups) => {

		let groupsHash = {};
		return participants.reduce((groups, participant) => {
		  let group = groupsHash[participant.group];

		  if(!group) {
		    group = groupsHash[participant.group] = {
		      id: participant.group_id || -1,
		      name: participant.group,
		      selected: _.contains(selectedGroups, participant.group_id),
		      items: []
		    };
		    groups.push(group);
		  }
		  
		  group.items.push(participant);
		  return groups;
		}, []);
	}
);

const menuItemsSelector = entitiesSelector(state => state.controls);

const navMenuSelector = createSelector(
	state => menuItemsSelector.getAll(state),
	state => getParticipantGroups(state, teachersSelector),
	state => getParticipantGroups(state, cohortsSelector),

	(menuItems, teacherGroups, cohortGroups) => {
		return {
			menuItems: menuItems,
			teacherGroups: teacherGroups,
			cohortGroups: cohortGroups
		};
	}
);

export default navMenuSelector;


/** WEBPACK FOOTER **
 ** ./src/js/selectors/nav_menu_selector.js
 **/